import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
const StyledButton = styled.button<ButtonProps>`
    background: ${(props) => props.primary ? props.customPalette.main : props.theme.colors.secondaryColor};
    color: ${(props) => props.primary ? props.theme.colors.secondaryTextColor : props.theme.colors.primaryTextColor};
    border: 1px solid ${(props) => props.primary ? props.customPalette.main : props.theme.colors.gray};
    padding: 16px 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-family: Mulish;
    font-size: ${ (props) => props.fontSize || '20px' };
    font-style: normal;
    font-weight: ${(props) => props.primary ? 400 : 300};
    line-height: 100%;
    letter-spacing: 1px;
    transition: 0.5s;
    cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
    opacity: ${(props) => props.disabled ? '0.5' : '1'};
    &:hover {
        background: ${(props) => props.primary ? props.customPalette.dark : props.theme.colors.secondaryHoverColor};
        color: ${(props) => props.primary ? props.theme.colors.secondaryTextColor : props.theme.colors.primaryTextColor};
        border: 1px solid ${(props) => props.customPalette.dark};
    }
`;

type CustomPaletteProps = {
  main: string,
  light: string,
  dark: string,
  contrastText: string,
};

type ButtonProps = {
  label?: string,
  primary?: boolean,
  type?: 'button' | 'submit' | 'reset',
  fontSize?: string,
  disabled?: boolean,
  onClick?: () => void,
  className?: string,
  loading?: boolean,
  customPalette?: CustomPaletteProps,
};

export default function Button({ label, type, primary, fontSize, onClick, disabled, className, loading, customPalette }: ButtonProps): JSX.Element {
  const theme = useTheme();
  let isOnClick = true;
  if (!customPalette) {
    customPalette = theme.palette.primary;
  }
  if (disabled || loading) isOnClick = false;
  return (<StyledButton
    className={className}
    theme={theme} fontSize={fontSize}
    type={type || 'button'}
    primary={primary || false}
    customPalette={customPalette}
    disabled={disabled}
    onClick={isOnClick ? onClick : () => { }}>
    {loading ? <CircularProgress size={'24px'} sx={{ color: theme.colors.secondaryTextColor }} /> : label || '...'}
  </StyledButton>);
}

